import type { FaireProductEntity } from "../../entity_types/product";

export const p_u23m575d56: FaireProductEntity = {
  token: "p_u23m575d56",
  type: "product",
  name: "Star Moon Ring Steel White Crystal Microset  S5P248",
  brandToken: "b_vzcwf2s2c8",
  brandName: "alberalkirk",
  imageUrl:
    "https://cdn.faire.com/fastly/8f4c6ef0285e605038b3baf6064967f16f99af67e686db1f9980ff238e7d1551.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e6fd397d8c1a03cc5c28c55a1c3f9f51c9d28acc9449ed42aa179cd16dbc29f9.jpeg",
    "https://cdn.faire.com/fastly/1dc61a160b9483e0550c138ba7b893f848eccee803892dfce9cdb42df1541ef4.jpeg",
    "https://cdn.faire.com/fastly/e69130c14e26f0286291f1225dd22eaf10bc4d4ca9393596b90357f0b7e68f8b.jpeg",
  ],
  priceDollars: 9.33,
  description:
    "Material: \n Stainless Steel \n\n Weight: \n 5G \n\n Feature: \n - Micro-Pavé White Crystal Stars \n - Crescent Moon Cutout Band \n - Solid Cast Construction \n - Comfort-Fit Curved Shank \n\n Care: \n - Clean with soft brush \n - Avoid impact on crystals \n - Store in ring box ",
  tags: [],
  msrpDollars: 18.65,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:12.775Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
